import React, { Component } from 'react';
import { Grid, Header, Segment, Container } from 'semantic-ui-react';

class Licenses extends Component {
  render() {
    return (
      <Segment style={{ padding: '7em 0em' }} vertical>
        <Container>
          <Grid stackable columns={4}>
            <Grid.Row>
              <Header as='h3' style={{ fontSize: '2.5em', fontFamiy: 'Raleway', fontFamily: 'serif'}}>Agency Licence Numbers </Header>
            </Grid.Row>
            <Grid.Row textAlign='center'>
              <Grid.Column>
                <Header as='h2'>California</Header>
                <p><b>0M04719</b></p>
              </Grid.Column>

              <Grid.Column>
                <Header as='h2'>Nevada</Header>
                <p><b>3319092</b></p>
              </Grid.Column>

              <Grid.Column>
                <Header as='h2'>Arizona</Header>
                <p><b>3000387355</b></p>
              </Grid.Column>

              <Grid.Column>
                <Header as='h2'>More States</Header>
                <p><b>coming soon!</b></p>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </Segment>
    );
  }
};

export default Licenses;



// WEBPACK FOOTER //
// ./src/js/Legal/Licenses.js